import { IconSize } from 'assets/icons/icon-sizes';
import LightBulbIcon from 'assets/icons/LightBulbIcon';
import { BodySmall, FlexCol } from 'components/Elements';
import styled from 'styled-components';
import { sizes, theme } from 'theme';

type HintProps = {
    hint: string;
    button?: JSX.Element;
};

export default function Hint({ hint, button }: HintProps): JSX.Element {
    return (
        <HintContainer>
            <Column>
                <TopRowContainer>
                    <IconAndText>
                        <LightBulbIconContainer>
                            <LightBulbIcon size={IconSize.MEDIUM} colour={theme.textColour} />
                        </LightBulbIconContainer>
                        <BodySmall>{hint}</BodySmall>
                    </IconAndText>
                </TopRowContainer>
                {button}
            </Column>
        </HintContainer>
    );
}

const IconAndText = styled.div`
    display: flex;
    align-items: center;
    gap: ${sizes.spacingMd};
`;

const LightBulbIconContainer = styled.div`
    width: ${sizes.spacingRg};
`;

const Column = styled(FlexCol)`
    gap: ${sizes.spacingMd};
`;

const TopRowContainer = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
`;

const HintContainer = styled.div`
    background-color: ${theme.courseEditHintBackgroundColour};
    padding: ${sizes.spacingRg};
    width: 100%;
`;
